export function getQueryStringValue(
    query: Record<string, string | (string | null)[]>,
    name: string
): string | null {
    if (!query) {
        return null;
    }

    for (const prop in query) {
        if (
            query.hasOwnProperty(prop) &&
            prop.toLowerCase() === name.toLowerCase()
        ) {
            return query[prop] as string;
        }
    }

    return null;
}
